'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '220 220 584 584' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M384 800l288-288-288-288v576z' })
    ));
};